// BlogDetailsArea.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogs } from "./../blogs"; // Import the blogs array from blogs.js

const BlogDetailsArea = () => {
  const { id } = useParams(); // Get the blog ID from the URL
  const blog = blogs.find((blog) => blog.id === parseInt(id)); // Find the blog by ID

  // If blog not found, return an error message
  if (!blog) {
    return <div>Blog not found</div>;
  }

  return (
    <div className="vs-blog-wrapper vs-blog-details space-top space-extra-bottom">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
            <div className="title-area">
              <span className="sec-subtitle">Blog Details</span>
              <h2 className="sec-title h1">{blog.title}</h2>
            </div>
          </div>
        </div>

        <div className="row gx-30">
          <div className="col-lg-12">
            <div className="vs-blog blog-single">
              <div className="blog-img">
                <img src={blog.mainImg} alt={blog.title} />
              </div>
              <div className="blog-content">
                <h2 className="blog-title">{blog.title}</h2>
                <div className="blog-meta">
                  <Link to="/blogs">
                    <i className="far fa-calendar"></i> {blog.date}
                  </Link>
                  <Link to="/blogs">
                    <i className="fal fa-user"></i> by {blog.authorName}
                  </Link>
                </div>
                <div className="blog-text">
                  {blog.content.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>

                <blockquote className="vs-blockquote">
                  <p>"{blog.quote}"</p>
                  <cite>{blog.authorName}</cite>
                </blockquote>

                <h3>Additional Insights</h3>

                <div className="row">
                  {blog.otherImgs.map((img, index) => (
                    <div className="col-xl-4 col-md-6 col-12" key={index}>
                      <div className="blog-inner-img">
                        <img
                          src={img}
                          alt={`blog imagee ${index + 1}`}
                          className="w-100"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <p>{blog.finalMessage}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsArea;
